import React, { useState, useEffect } from "react";
import ZenVerBarChart from "../../../components/ManagerDashboard/Common/Graph/ZenVerBarChart";
import liracrypt from "../../../components/Liracrypt/liracrypt";
import SessionError from "../../../components/ApiErrorComp/SessionError";
import ApiErrorComp from "../../../components/ApiErrorComp/ApiErrorComp";


const LineDashBarChart = (props) => {
  const [data, setData] = useState(null);
  const [config, setConfig] = useState(null);
  const [loginError, setLoginError] = useState(false);

  const fetchPerformanceData = () => {
    liracrypt

      .get("linedash/tabs/barchart", {
        lid: props.selectedLid,
        tab: props.selectedTab
       
      })
      .then(({ data }) => {
        const fetchdata = data.data ? data.data : [];
        setConfig(data.config);
        setData(fetchdata);
      })
      .catch(function (error) {
        console.log("Error****:");
        if (error.response !== undefined) {
          if (error.response.status !== 401) {
            ApiErrorComp(error.response.status);
          } else {
            setLoginError(true);
          }
        }
      });
  };

  useEffect(() => {
      fetchPerformanceData();
  }, [props.selectedTab]);

  return (
    <>
      <SessionError visible={loginError} />
      <div
        style={{
          borderRadius: "10px",
          boxShadow: "inset 5px 5px 9px #171717,inset -5px -5px 9px #232323",
          overflow: "hidden",
          minHeight: "450px",
        }}
      >
        {config && data ? (
       
          <ZenVerBarChart
          divId={"ZenVerBarChart1"}
          data={data}
          config={config}
          onChange={(data) => this.changeBasicGraph(data)}
        />
        ) : (
          <></>
        )}
      </div>
    </>
  );
};

export default LineDashBarChart;
